<template>
	<div class="gb-photoalbum-content-album">
		<v-toolbar flat color="white">
			<v-toolbar-title class="px-2">アルバム</v-toolbar-title>
		</v-toolbar>
		<div>
			<v-layout v-if="!hidden" align-start justify-start row wrap class="gb-photoalbum-content-album-layout ma-2 pa-0">
				<v-card tile raised hover class="add-album ma-2" v-if="select_id">
						<v-btn flat class="add-album-btn ma-0 primary" @click="onCreateNewAlbum"><v-icon x-large>add_photo_alternate</v-icon></v-btn>
				</v-card>
				<GBPhotoAlbumContentItemAlbum 
					v-for="item in items"
					v-bind:key="item.code"
					v-bind:album="item"
					v-bind:download_album="download_album"
					v-on:download-album="onDownloadAlbum"
					v-on:delete-album="onDeleteAlbum"
				/>
			</v-layout>
			<v-btn 
				absolute
				dark
				fab
				bottom
				right
				color="pink"
				v-if="select_id"
				@click="onClickHidden">
					<v-icon v-if="hidden" >arrow_downward</v-icon>
					<v-icon v-else>arrow_upward</v-icon>
			</v-btn>
		</div>
	</div>
</template>
<script>
import GBPhotoAlbumContentItemAlbum from './GBPhotoAlbumContentItemAlbum';

export default {
	name: 'GBPhotoAlbumContentAlbum',
	props: [
		"items", "select_id", "download_album"
	],
	data (){
		return{
			hidden: false,
		}
	},
	components: {
		GBPhotoAlbumContentItemAlbum,
	},
	methods: {
		onCreateNewAlbum: function() {
			let uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.select_id, 'create'].join('/');
			this.$router.push(uri);
		},
		onClickHidden: function() {
			this.hidden = !this.hidden;
		},
		onDownloadAlbum: function(e) {
			this.$emit('download-album', e);
		},
		onDeleteAlbum: function(e) {
			this.$emit('delete-album', e);
		},
	},
	computed: {
	},
};

</script>
<style>
	.gb-photoalbum-content-album {
		position: relative;
		border-top:solid 1px #DFDFDF;
		border-bottom:solid 1px #DFDFDF;
		width: 100%;
		background-color: #fff;
	}
	.gb-photoalbum-content-album .gb-photoalbum-content-album-layout {
		position: relative;
	}
	.gb-photoalbum-content-album .gb-photoalbum-content-album-layout .add-album {
		position: relative;
		width: 202px;
		height: 247px;
	}
	.gb-photoalbum-content-album .gb-photoalbum-content-album-layout .add-album-btn {
		width: 100%;
		height: 100%;
	}
</style>
